import * as React from "react";

const SvgStop = ({ color, size }) => (
  <svg
    viewBox="0 0 24 24"
    width={`${24 * (size || 1)}px`}
    height={`${24 * (size || 1)}px`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke={color}
      strokeWidth={2}
    >
      <path d="M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z" />
      <path d="M9.333 10.222c0-.49.398-.889.89-.889h3.555c.49 0 .889.398.889.89v3.555c0 .49-.398.889-.89.889h-3.555a.889.889 0 0 1-.889-.89v-3.555Z" />
    </g>
  </svg>
);

export default SvgStop;
